export const staircaseConfig = {
    gameSlug: 'true-north',
    category: 'terre_navigation',
    variable: 'n_items',
    startValue: 2,
    minValue: 1,
    maxValue: 6,
    stepSizesByPhase: [1, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 16,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, pathShowMs: 5000, acceptanceDeg: 35, label: 'Trajet court' };
    }
    if (level <= 20) {
        return { level, pathShowMs: 4500, acceptanceDeg: 30, label: 'Charge integration' };
    }
    if (level <= 30) {
        return { level, pathShowMs: 4000, acceptanceDeg: 25, label: 'Precision attendue' };
    }
    if (level <= 40) {
        return { level, pathShowMs: 3500, acceptanceDeg: 20, label: 'Trajet long' };
    }
    return { level, pathShowMs: 3000, acceptanceDeg: 15, label: 'Limite path integration' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durées non-staircase. */
export const timing = {
    fixationMs: 400,
    segmentAnimMs: 700,
    feedbackMs: 800,
    itiMs: 700,
};
export const paradigmMeta = {
    slug: 'true-north',
    paradigm: 'Path integration / Triangle Completion (Loomis et al. 1993)',
    masterMage: 'Garek (terre-navigation)',
    category: 'terre_navigation',
    goal: 'Sens de l orientation : voyages, conduite, randonnee, vie urbaine.',
};
/**
 * Erreur angulaire absolue entre deux bearings (degrés).
 * Retourne une valeur dans [0, 180].
 */
export function angularError(picked, truth) {
    const norm = (a) => ((a % 360) + 360) % 360;
    const diff = Math.abs(norm(picked) - norm(truth));
    return Math.min(diff, 360 - diff);
}
//# sourceMappingURL=params.js.map